import React, { useState } from 'react';
import {
  Box,
  Container,
  Text,
  Image,
  IconButton,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverCloseButton,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  ButtonGroup,
  Button,
  useToast
} from '@chakra-ui/react';
import { CircleX } from 'lucide-react';
import { useFontsState } from '../hooks/fonts';
import ImageView from './ImageView';
import { useImage } from 'hooks/useImage';
import useDeleteFont from 'hooks/useDeleteFont';

const FontItem = React.memo((props) => {
  // const fontNameLowercase = (props.fontName + '').toLowerCase();
  const [borderColor, setBorderColor] = useState(null);

  const { addFontToFilter } = useFontsState();
  const deleteFont = useDeleteFont();
  const toast = useToast();

  const handleDelete = () => {
    deleteFont.mutate(props.font, {
      onSuccess: () => {
        toast({
          title: 'Font deleted',
          description: 'Font has been successfully deleted',
          status: 'success',
          duration: 3000,
          isClosable: true
        });
      },
      onError: (error) => {
        console.error('Delete font error:', error);
        toast({
          title: 'Error deleting font',
          description:
            'There was an error deleting the font. Please try again.',
          status: 'error',
          duration: 3000,
          isClosable: true
        });
      }
    });
  };

  const ConfirmDeletePopover = () => {
    return (
      <Popover placement="bottom" closeOnBlur={true} isLazy>
        {({ isOpen, onClose }) => (
          <>
            <PopoverTrigger>
              <IconButton
                aria-label="Delete font"
                icon={<CircleX size={20} />}
                size="sm"
                variant="ghost"
                colorScheme="gray"
                position="absolute"
                top={2}
                right={2}
                onClick={(e) => e.stopPropagation()}
                _hover={{
                  background: 'red.50',
                  color: 'red.500'
                }}
              />
            </PopoverTrigger>
            <PopoverContent>
              <PopoverCloseButton />
              <PopoverHeader>Delete Font</PopoverHeader>
              <PopoverBody>
                <Text whiteSpace={'normal'}>
                  Are you sure you want to delete &quot;
                  {props.font.display_name || props.font.font_family}&quot;?
                </Text>
              </PopoverBody>
              <PopoverFooter
                border="0"
                d="flex"
                alignItems="center"
                justifyContent="space-between"
                pb={4}
              >
                <ButtonGroup size="sm">
                  <Button
                    aria-label="Cancel"
                    colorScheme="gray"
                    onClick={onClose}
                  >
                    Cancel
                  </Button>
                  <Button
                    aria-label="Yes"
                    colorScheme="red"
                    onClick={() => {
                      onClose();
                      handleDelete();
                    }}
                  >
                    Delete
                  </Button>
                </ButtonGroup>
              </PopoverFooter>
            </PopoverContent>
          </>
        )}
      </Popover>
    );
  };

  return (
    <>
      <Box
        cursor="pointer"
        // maxWidth="350px"
        flexGrow="1"
        flexShrink="1"
        borderRadius="md"
        boxShadow="2xl"
        m={3}
        background="white"
        padding={3}
        variant="outline"
        position="relative"
        // display={props.font.selected ? 'block' : 'none'}
        //TODO
        // border={borderColor}
        onClick={(e) => {
          if (borderColor === null) {
            setBorderColor('3px solid orange');
            // addFontToFilter(props.font.id, true);
          } else {
            setBorderColor(null);
            // addFontToFilter(props.font.id, false);
          }
        }}
      >
        {/* Show delete button only for custom fonts and when showDelete is true */}
        {props.type === 'custom' && props?.showDelete && (
          <ConfirmDeletePopover />
        )}
        <style
          dangerouslySetInnerHTML={{
            __html: `
          @font-face { font-family: '${props.font.font_family_alias}'; src: url('${props.font.url}');
          `
          }}
        />

        <Text fontSize="lg" color="grey" textAlign="left">
          {props.type === 'custom'
            ? // ? props.font.font_family + '.' + props.font.font_type
              props.font.display_name
            : props.font.font_family}
        </Text>
        {props.image ? (
          <Container textAlign="center" position="relative" maxWidth="300px">
            <Image
              // boxSize="600px"
              width="100%"
              src={props.image}
            />
            <Text
              position="absolute"
              top="50%"
              left="50%"
              transform="translate(-50%, -50%)"
              fontFamily={props.font.font_family_alias}
              fontSize={props.fontSize}
              textTransform={props.textCase}
              color={props.color ? props.color : '#000000'}
              whiteSpace="pre-wrap"
            >
              {props.text}
            </Text>
          </Container>
        ) : props.imageId ? (
          <Container textAlign="center" position="relative" maxWidth="300px">
            <ImageView imageId={props.imageId} />
            {/* <Image
              // boxSize="600px"
              width="100%"
              src="https://fontvisual-dev.s3.amazonaws.com/d80b7783-fdcf-417e-9959-e23926e45a5a/images/mockup2.jpg"
            /> */}
            <Text
              position="absolute"
              top="50%"
              left="50%"
              transform="translate(-50%, -50%)"
              fontFamily={props.font.font_family_alias}
              fontSize={props.fontSize}
              textTransform={props.textCase}
              color={props.color ? props.color : '#000000'}
              whiteSpace="pre-wrap"
            >
              {props.text}
            </Text>
          </Container>
        ) : (
          <Box
            textAlign="center"
            alignContent="center"
            alignItems="center"
            justifyContent="center"
            fontFamily={props.font.font_family_alias}
            fontSize={props.fontSize}
            textTransform={props.textCase}
            color={props.color ? props.color : '#000000'}
            p={2}
            whiteSpace="pre-wrap"
          >
            {props.text}
          </Box>
        )}
      </Box>

      {/* <div className={styles.fontItem}>
        <h1 className={styles.fontName}>{fontNameLowercase}</h1>
        <div style={props.style}>{props.text}</div>
      </div> */}
    </>
  );
});

export default FontItem;
